export const listTabsPortfolio = [
  {
    id: 'todos',
    title: 'Todos',
  },
  {
    id: 'web',
    title: 'Paginas Web',
  },
  {
    id: 'aplicacion',
    title: 'Aplicaciónes Web',
  },
];

export const projectsData = [
  // {
  //   id: 1,
  //   tab: 'web',
  //   title: 'Centro Virgen Niña',
  //   description:
  //     'Sitio Web desarrollado para la Asociación Centro Virgen Niña que brinda atención a niñ@s con discapacidad y familias en estado de pobreza, dicho sitio tiene el objetivo de brindar información sobre las especialidades, plantel docente y de sus contactos en redes sociales.',
  //   image: 'img/portfolio/thumb/centro-virgen.png',
  //   category: 'sitio-web',
  //   date: '2021',
  //   client: 'Centro Virgen Niña',
  //   tools: 'React',
  //   url: 'https://centrovirgenninaepdb.edu.bo/',
  //   images:
  //     'img/portfolio/large/CentroVirgen/1.png, img/portfolio/large/CentroVirgen/2.png, img/portfolio/large/CentroVirgen/3.png',
  // },
  {
    id: 1,
    tab: 'web',
    title: 'Cafetería',
    description:
      'Sitio Web desarrollado para la Asociación Centro Virgen Niña que brinda atención a niñ@s con discapacidad y familias en estado de pobreza, dicho sitio tiene el objetivo de brindar información sobre las especialidades, plantel docente y de sus contactos en redes sociales.',
    image: 'img/portfolio/thumb/cafeteria2.png',
    category: 'sitio-web',
    date: '2021',
    client: 'Proyecto personal',
    tools: 'React',
    url: 'https://cafeteria-page.netlify.app',
    images:
      'img/portfolio/large/CentroVirgen/1.png, img/portfolio/large/CentroVirgen/2.png, img/portfolio/large/CentroVirgen/3.png',
  },
  {
    id: 2,
    tab: 'web',
    title: 'Restaurant',
    description:
      'Pagina Web realizada como práctica personal para un Restaurant que brinda información sobre los platillos que se sirven, los chefs, historia del restaurant así como información de contacto.',
    image: 'img/portfolio/thumb/restaurant.png',
    category: 'sitio-web',
    date: '2020',
    client: 'Proyecto Personal',
    tools: 'HTML, CSS, Javascript',
    url: 'https://upbeat-davinci-1ac91e.netlify.app/',
    images: 'img/portfolio/large/restaurant/1.png',
  },
  {
    id: 3,
    tab: 'web',
    title: 'Portafolio Fotógrafa',
    description:
      'Pagina Web realizada como práctica personal, es un portafolio de una Fotógrafa donde puede mostrar los servicios que proporciona, los fotografías que realizó a lo largo de su carrera, así como su información de contacto .',
    image: 'img/portfolio/thumb/fotografa.png',
    category: 'sitio-web',
    date: '2020',
    client: 'Proyecto Personal',
    tools: 'HTML, CSS, Javascript',
    url: 'https://objective-wiles-72060a.netlify.app/',
    images: 'img/portfolio/large/fotografa/1.png',
  },
  {
    id: 4,
    tab: 'web',
    title: 'Bienes Raices',
    description:
      'Sitio Web para Bienes Raices que tiene la finalidad de brindar información de cada una de las casa en venta, mostrando el precio y la descripción de cada una de ellas, asi como también su blog y contacto para las personas que esten interesadas.',
    image: 'img/portfolio/thumb/bienes-raices.png',
    category: 'sitio-web',
    date: '2019',
    client: 'Proyecto Personal',
    tools: 'React',
    url: 'https://bienes-raices-phi.vercel.app/',
    images:
      'img/portfolio/large/BienesRaices/1.png, img/portfolio/large/BienesRaices/2.png, img/portfolio/large/BienesRaices/3.png, img/portfolio/large/BienesRaices/4.png, img/portfolio/large/BienesRaices/5.png',
  },
  {
    id: 5,
    tab: 'aplicacion',
    title: 'CRUD - Productos',
    description:
      'Aplicación que permite la administración de productos, el usuario puede crear productos y proporcionarle un precio también podra editar dicha información y eliminar el producto si es necesario.',
    image: 'img/portfolio/thumb/crud-productos.png',
    category: 'aplicación-web',
    date: '2020',
    client: 'Proyecto Personal',
    tools: 'React, Redux, Firebase',
    url: 'https://crud-productos-redux.vercel.app/',
    images:
      'img/portfolio/large/CrudProductos/1.png, img/portfolio/large/CrudProductos/2.png',
  },
  {
    id: 6,
    tab: 'aplicacion',
    title: 'Gestor de Proyectos',
    description:
      'Aplicación realizada para la gestión de tareas, permitirá al usuario poder crearse una cuenta y comenzar a gestionar las tareas para cada uno de sus Proyectos, actualizarlas, marcarlas como completadas y eliminarlas.',
    image: 'img/portfolio/thumb/merntask.png',
    category: 'aplicación-web',
    date: '2020',
    client: 'Proyecto Personal',
    tools: 'MongoDB, Express, React (Redux), NodeJS',
    url: 'https://mern-task-redux.vercel.app/',
    images:
      'img/portfolio/large/MernTask/2.png, img/portfolio/large/MernTask/1.png',
  },
];
